import { runningInIframe } from "@app/environmentsBasic";
import { defaultTags } from "@app/services/sentry/SentryTags";

export type SharedEnvironmentContext = Record<string, unknown> & {
	"Environment Type": string;
	"GPU Name": string;
};

export interface MachineEnvironmentContext extends SharedEnvironmentContext {
	"Run Type": "Standalone" | "From Lobby";
	"Server Build Number": number;
	"Server Version": number;
}

export interface WebAndMobileEnvironmentContext extends SharedEnvironmentContext {
	"Is mobile": boolean;
	"Running in iFrame": boolean;
	"Running in Web Jackpots Frame": boolean;
	"Is Browser Supported": boolean;
	"Internet Connection Type": string | undefined;
	"Internet Effective Type": string | undefined;
	"Screen Size": string;
}
/**
 * Context which is available at the very start of app.
 */
export class BasicSentryEnvironmentContexts {

	public static createBasicWebAndMobileContext() {
		return {
			"Environment Type": "Web",
			"Internet Connection Type": (navigator as any).connection?.type ?? undefined,
			"Internet Effective Type": (navigator as any).connection?.effectiveType ?? undefined,
			"Is mobile": defaultTags["Is Mobile"],
			"Screen Size": (window?.innerWidth) ? (window.innerWidth + "x" + window.innerHeight) : "unknown",
			"Running in iFrame": runningInIframe,
		} satisfies Partial<WebAndMobileEnvironmentContext>;
	}

	public static createBasicMachineContext() {
		return {
			"Environment Type": "Machine"
		} satisfies Partial<MachineEnvironmentContext>;
	}
}